import React, { useEffect } from 'react';
import { Container, Paper, Box, Typography, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ResetSuccess: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the home page after 3 seconds
    const timer = setTimeout(() => {
      navigate('/signin');
    }, 3000);

    // Cleanup the timer if the component unmounts before the timer completes
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ padding: 4, mt: 8 }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <img src="logo.png" alt="Logo" style={{ width: '150px', marginBottom: '20px' }} />
          <Typography variant="h4" gutterBottom>Password Reset Success</Typography>
          <Typography variant="body1" align="center" gutterBottom>
            Your password has been successfully reset! You will be redirected to the home page in a few seconds.
          </Typography>
          <CircularProgress sx={{ mt: 2 }} />
        </Box>
      </Paper>
    </Container>
  );
};

export default ResetSuccess;
